// ApplyNow/ApplyNow.jsx
import React from 'react';
import { Button } from 'react-bootstrap';
import './ApplyNow.css';

const ApplyNow = ({ brokerName }) => {
  return (
    <div className="apply-now-container" id='Apply-Now'>
      {/* <div className="apply-now-heading">Apply Now</div> */}
      
      <div className="broker-info-section">
        <h2 className="about-broker">About {brokerName}</h2>
        <div className="broker-intro">
          With {brokerName}, you will receive
        </div>
        
        <ul className="benefits-list">
          <li>
            <span className="benefit-highlight">Access</span> to the most competitive rates 
            and the most complete line of products
          </li>
          <li>
            Strong client-focus and a desire to <span className="benefit-highlight">win 
            your business</span>
          </li>
          <li>
            The <span className="benefit-highlight">peace of mind</span> that comes with an 
            unsurpassed level of post-sales support
          </li>
          <li>
            A prompt, professional, and courteous <span className="benefit-highlight">
            response</span> to your inquiries
          </li>
          <li>
            An ongoing commitment to <span className="benefit-highlight">excellence 
            and service</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ApplyNow;